import { getCssVariableValue } from 'frontend-utils/utils/css-variable';
import { getHotelMarkerSvg } from 'lumen/utils/map-markers';

export const COMPETITORS_MAP_STYLES: google.maps.MapTypeStyle[] = [
  {
    featureType: 'administrative',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
];

export const COMPETITORS_MAP_OPTIONS: google.maps.MapOptions = {
  disableDefaultUI: true,
  zoom: 14,
  zoomControl: false,
  scaleControl: true,
  disableDoubleClickZoom: false,
  draggable: false,
  draggableCursor: 'cursor',
  zoomControlOptions: {
    position: google.maps.ControlPosition.LEFT_BOTTOM,
  },
};
const iconConfig = {
  path: google.maps.SymbolPath.CIRCLE,
  fillOpacity: 1,
  scale: 8,
  strokeWeight: 2,
  strokeColor: getCssVariableValue('--prism-color-border-inverse-emphasis'),
  // Override the default anchor point to make the marker appear at the correct location
  anchor: new google.maps.Point(0, 1),
};
export const COMPETITORS_MAP_ICONS = {
  COMPSET: {
    ...iconConfig,
    fillColor: getCssVariableValue(
      '--prism-color-chart-accent-primary-figure-emphasis',
    ),
  },
  OWN: {
    url: getHotelMarkerSvg(),
    scaledSize: new google.maps.Size(30, 30),
  },
  HIGHLIGHTED: {
    ...iconConfig,
    scale: 10,
    fillColor: getCssVariableValue(
      '--prism-color-chart-accent-primary-figure-subdued',
    ),
  },
  COMPSET_SUGGESTED: {
    ...iconConfig,
    fillColor: getCssVariableValue(
      '--prism-color-chart-intelligence-figure-high',
    ),
  },
  COMPSET_SUGGESTED_HIGHLIGHTED: {
    ...iconConfig,
    scale: 10,
    fillColor: getCssVariableValue(
      '--prism-color-chart-intelligence-background-normal-emphasis',
    ),
  },
} as const;
